<template>
<div class="cockpit-selector">
  <div class="campaign-name-selector">
    <div class="selected" @click='toggleSelector'>

      <h3 class="title">
        {{ campaignSelectedName}}
        <i v-if='!loading' class="pull-right fa" :class='caret()' aria-hidden="true"/>
        <i v-if='loading' class="fa fa-spinner fa-pulse"/>
      </h3>

    </div>
    <div class="selector" v-if='selector'>

      <ul @mouseleave='closeSelector'>
        <li @click='selectCampaign(item.id)' v-for="item in campaigns" :key="item.id">
          {{item.name}}
        </li>
      </ul>

    </div>
  </div>
</div>
</template>

<script>
import find from 'lodash.find'

export default {
  props: ['campaigns', 'loading', 'value'],
  data () {
    return {
      selector: false
    }
  },
  computed: {
    campaignSelectedName () {
      var self = this
      if (self.campaigns.length) {
        return find(self.campaigns, function (o) {
          return o.id === self.value
        }).name
      } else {
        return ''
      }
    }
  },
  methods: {
    toggleSelector () {
      this.selector = !this.selector
    },
    closeSelector () {
      this.selector = false
    },
    selectCampaign (id) {
      this.selector = false
      this.$emit('input', id)
    },
    caret () {
      return {
        'fa-caret-up': this.selector,
        'fa-caret-down': !this.selector
      }
    }
  }
}
</script>

<style scoped lang="stylus" src="../styles/_CockpitSelector.styl"/>



// WEBPACK FOOTER //
// src/components/CockpitSelector.vue